import styled from 'styled-components';
import { TableRow, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Title = styled(Typography)`
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: bold;
  padding: 20px 0 30px;
  font-size: 3.75rem;
`;

export const ImagePreview = styled.img`
  width: 32%;
  margin-right: 10px;
  cursor: pointer;
`;

export const StyledTableRow = styled(TableRow)`
  background-color: ${({ $type }) => $type && 'rgba(204 204 204 / 40%)'};
`;

export const FileIcon = styled(FontAwesomeIcon)`
  font-size: 20px;
  margin-right: 10px;
`;
